module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Section0",
    staticStyle: {
      "layout-grid": "15.6000pt"
    }
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "text-align": "center"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品许可与服务协议")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("欢迎使用")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品及服务！")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("在使用")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品（以下简称")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("“")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("本产品")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("”")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）及服务之前，请您仔细阅读下述许可与服务协议条款，充分理解各条款内容，特别是免除或限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("除非您已阅读并接受本协议所有条款，否则您无权使用本产品及相关服务。一旦您注册、登录及使用本产品，即表示您已接受了以下所述的条款和条件，同意受本协议约束。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("您有违反本协议的任何行为时，我方有权依照您违反情况随时单方采取限制、中止或终止向您提供服务等措施，并有权追究您相关责任。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("一、协议适用主体范围")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("本协议的缔约方为使用本产品及相关服务的用户（简称")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("“")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("您")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("”")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）与本产品及服务提供商")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("广州市东迅电脑科技有限公司")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（简称")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("“")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("我方")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("”")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）之间，就您注册、登录、使用本产品所订立的协议。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("二、协议内容和效力")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、本协议内容包括本协议正文及所有我们已经发布或将来可能发布的隐私权政策、各项政策、规则、声明、通知、警示、提示、说明（简称")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("“")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("规则")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("”")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）。前述规则为本协议不可分割的组成部分，与本协议具有同等法律效力。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、我方有权根据需要不时制订、修改本协议及相关规则，变更后的协议和规则将提前七天公告的形式通知您，并经公告完毕后即取代原协议及规则生效。如您不同意相关变更，应当立即停止使用")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品及服务；如您继续使用")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品及服务或进行任何网站活动，即表示您已接受经修订的协议和规则。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("三、服务内容")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品和服务包括")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("小程序中各项功能的使用以及工资条的通知载体短信或邮件服务。我方会不断丰富您使用本产品及服务的终端、形式等，如您已注册或登录使用，本协议自动适用于您对所有版本和终端的产品和服务的使用。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、我方依据本协议以及其他使用的规则，许可您对")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品进行不可转让的、非排他性的使用。本协议其他条款未明示授权的其他一切权利仍由我方保留，您在行驶这些权利时须另外取得我方的书面许可。我方如果未行使前述任何权利，并不构成对该权利的放弃。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、本服务内容包含支持工资条发放、管理、查看等技术功能，这些功能服务可能根据用户需求的变化，随着因服务版本不同、或我方判断而被优化或修改，或因定期、不定期的维护而暂缓提供。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、为了保证本产品及服务的安全性和功能的一致性，我方有权不经向用户特别通知而对产品或服务任何部分及其相关功能进行变更、升级、修改、转移。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、本产品及服务新版本发布后，旧版本的部分功能可能无法使用。我方不保证旧版本功能及相应的客户服务继续可用。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("6"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您理解并同意，我方可能通过公告、更新日志等方式向您通知产品及服务更新情况，但我方不需向您特别通知。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("四、注册、登录及账号管理")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您确认，在您完成注册或登录使用时，您应当是具备完全民事权利能力和所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用服务，否则您及您的监护人应承担因此而导致的一切后果，且我方有权注销（永久冻结）您的账号，并向您及您的监护人索偿。如您代表一家企业、组织机构或其他法律主体进行注册或登录使用本产品及服务，则您声明和保证，您已经获得充分授权并有权代表该公司、组织机构或法律主体注册使用我方产品及服务，并受本协议地约束。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您可以使用您提供或确认的手机号作为账号进行注册、登录，您注册、登录时应提交真实、准确、完整和反馈当前情况的身份及其他相关信息。您理解并同意，您承诺注册的企业名称、联系人等信息中不得出现违法和不良信息，不得冒充他人，不得未经许可为他人注册，不得以可能导致其他用户误认的方式注册账号，不得使用可能侵犯他人权益的企业名称（包括但不限于涉嫌商标权、名誉权侵权等），否则您应承担因此而导致的一切后果，同时我方有权不予注册或停止服务并收回账号，因此产生的损失由您自行承担。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您了解并同意，")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("注册账号所有权归属于我方，注册完成后，您仅获得账号使用权。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("账号使用权仅归属于初始申请注册人，不得在未经授权或许可的情况下，以任何方式转让或被提供予他人使用，否则，我方有权立即不经通知收回该账号，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您应妥善保管使用本产品及服务的个人密码，使用个人密码而发生的行为均视为您的个人行为。若因您保管个人密码失当而出现密码、公告等相关信息泄露事件，对于因此造成的损失，我方不承担任何赔偿责任。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、如您停止使用本产品或服务时，我方有权自行对账号相关内容及信息以包含但不限于删除等方式进行处理，且无需就此向用户承担任何责任。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("五、服务使用规范")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您充分了解并同意，我方仅为用户提供服务平台，您应自行对利用服务从事的所有行为及结果承担责任。相应地，您应了解，使用我方服务可能发生来自他人非法或不当行为（或信息）的风险，您应自行判断及行动，并自行承担相应的风险。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您应自行承担因使用服务所产生的费用，包括但不限于上网流量费、通信服务费等。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、除非另有说明，本协议项下的服务只能用于非商业用途。您承诺不对本服务任何部分或本服务之使用或获得，进行复制、拷贝、出售、转售或用于包括不限于广告及任何其它商业目的。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您承诺不会利用本服务进行任何违法或不当的活动，包括但不限于下列行为：")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4.1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("上载、传送或分享含有下列内容之一的信息：")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(0), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("1")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）反对宪法所确定的基本原则的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("2")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(2), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("3")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）损害国家荣誉和利益的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(3), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("4")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）煽动民族仇恨、民族歧视，破坏民族团结的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(4), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("5")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）破坏国家宗教政策，宣扬邪教和封建迷信的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(5), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("6")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）散布谣言，扰乱社会秩序，破坏社会稳定的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(6), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("7")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(7), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("8")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）侮辱或者诽谤他人，侵害他人合法权益的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(8), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("9")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其他道德上令人反感的内容")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "MsoNormal",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "text-indent": "10.5000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt",
      "mso-list": "l0 level1 lfo1"
    }
  }, [_vm._m(9), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("（")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("10")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）含有中国国家管辖法所适用的法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "10.5000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4.2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("冒充任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4.3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("将涉嫌侵害他人权利（包括但不限于著作权、专利权、商标权、商业秘密等知识产权）之内容上载、传送或分享；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4.4"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("违反遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("“")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("七条底线")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("”")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("要求的行为；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4.5"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("从事任何违反中国法律、法规、规章、政策及规范性文件的行为。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您承诺不对本产品和服务从事以下行为：")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5.1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序等资料，加以上载、发送；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5.2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或规范；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5.3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("通过修改或伪造产品中的指令、数据，增加、删减、变动产品的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5.4"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("通过非我方公司开发、授权的第三方软件、插件、外挂、系统，登录或使用产品及服务，或制作、发布、传播上述工具；")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("5.5"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("自行、授权他人或利用第三方软件对本产品及其组件、模块、数据等进行干扰。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("6"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您承诺，使用")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("产品及服务时您将严格遵守本协议。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("7"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您同意并接受我方有权对您使用服务的情况进行审查、监督并采取相应行动，包括但不限于删除信息、中止或终止服务，及向有关机关报告。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("8"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您承诺不以任何形式使用本服务侵犯我方的商业利益，或从事任何可能对我方造成损害或不利于我方的行为。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("六、服务费用")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt",
      "background": "rgb(0,255,255)",
      "mso-highlight": "rgb(0,255,255)"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("本服务的任何免费试用或免费功能和服务不应视为我方放弃后续收费的权利。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("我方有权提前")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("7")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("天通过合理的途径以公告的形式通知您收费标准及收费方式。若您继续使用")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("相关服务，则需按我方公布的收费标准支付相应费用。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、我方有权根据实际情况提前")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("7")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("天单方面调整费用标准及收费方式，并以公告形式通知您，而无需获得您的事先同意，如您不同意收费应当立即停止服务的使用，否则使用规则视为您已同意并应当缴纳费用。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("七、服务中止或终止")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、鉴于互联网服务的特殊性，我方有权对服务内容进行变更，也可能会中断、中止或终止全部或者任一部分的服务，包括免费服务")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("或收费服务，并在")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("官网上以公示的形式通知您。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您了解并同意，我方可能定期或不定期地对提供网络服务的平台设备、设施和软硬件进行维护或检修，如因此类情况而造成收费服务在合理时间内中止，我方无需承担责任，但应事先在我方官网以公示的形式通告您。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("八、隐私政策")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt",
      "background": "rgb(0,255,255)",
      "mso-highlight": "rgb(0,255,255)"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("我方保证为其知悉的与您有关的信息保守秘密，所涉及到的资料，包括：通讯录、组织机构、业务数据等双方认可确认的需要保密的资料。本协议约定的保密资料不设保密期限，永久保密。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt",
      "background": "rgb(0,255,255)",
      "mso-highlight": "rgb(0,255,255)"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("我方努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您存储在")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt",
      "background": "rgb(0,255,255)",
      "mso-highlight": "rgb(0,255,255)"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt",
      "background": "rgb(0,255,255)",
      "mso-highlight": "rgb(0,255,255)"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("中的信息不会被泄漏、毁损或者丢失，包括但不限于")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("SSL")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、信息加密存储、数据中心的访问控制。我们对可能接触到信息的员工也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。我方会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我方将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失，但同时也请您注意在信息网络上不存在绝对完善的安全措施，请妥善保管好相关信息。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt",
      "background": "rgb(0,255,255)",
      "mso-highlight": "rgb(0,255,255)"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、保密协议生效的前提为不违反中华人民共和国的法律法规，不危害社会安全，不危损害国家利益。下列情形保密协议不具备法律效力：")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3.1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、在您公布前，我方已经知道的信息，或者非您的错误行为导致的信息早已公开。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3.2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您没有对我方发布限制要求的情况下，公布的信息。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("九、免责条款")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、因地震、山洪、雷电、台风等自然灾害、电磁干扰、火灾、政府行为等不可抗力因素导致双方或者一方不能履行或者不能完全履行本协议中有关义务时，遭受不可抗力的任何一方不承担违约责任。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、行政机关要求本协议终止履行的，双方互不承担责任，但应协商处理善后事宜。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("十、知识产权")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您了解及同意，除非我方另行声明，本协议项下服务包含的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归我方所有。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您应保证，除非取得我方书面授权，对于上述权利您不得（并不得允许任何第三人）实施包括但不限于出租、出借、出售、散布、复制、修改、转载、汇编、发表、出版、还原工程、反向汇编、反向编译，或以其它方式发现原始码等的行为。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("的")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("Logo")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("“")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("”"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("等文字、图形及其组合，以及我方其他标识、徽记、")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("服务的名称等为我方在中国的注册商标。未经我方书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、我方所有的产品、服务、技术与所有应用程序或其组件")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("/")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("功能")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("/")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("名称（以下或简称")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("“")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("技术服务")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("”")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("）的知识产权均归属于我方所有。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("十一、违约责任")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、如果我们发现或收到他人举报您有违反本协议约定的，我方有权不经通知随时对相关内容进行删除、屏蔽，并采取包括但不限于限制、暂停、终止您使用")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("东迅工资条")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("账号及服务，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您同意，由于您通过服务上载、传送或分享之信息、使用本服务其他功能、违反本协议、或您侵害他人任何权利因而衍生或导致任何第三人向我方提出任何索赔或请求，或我方因此而发生任何损失，您同意将足额进行赔偿（包括但不限于合理律师费）。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("十二、有效通知")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、我方向您发出的任何通知，可采用电子邮件、页面公开区域公告、个人网络区域提示、手机短信或常规信件等方式，且该等通知应自发送之日起")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("7")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("天内视为已向用户送达或生效。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、您同意，您向我方发出的任何通知应发至我方对外正式公布或以第十四条所述方式告知用户的线上或线下联系方式、通信地址、等联系信息，或使用其他我方认可的其他通知方式进行送达。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("十三、争议解决及其他")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("1"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("2"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部份则仍具有法律效力。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("3"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、我方于用户过失或违约时放弃本协议规定的权利的，不得视为其对用户的其他或以后同类之过失或违约行为弃权。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_vm._v("4"), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("、本协议应取代双方此前就本协议任何事项达成的全部口头和书面协议、安排、谅解和通信。")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan"
    }
  }, [_c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("十四、联系方式")])], 1)]), _c('b', {
    staticStyle: {
      "mso-bidi-font-weight": "normal"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ansi-font-weight": "bold",
      "font-size": "13.5000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  })], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("广州市东迅电脑科技有限公司      020-83878320")])], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "宋体",
      "mso-ascii-font-family": "Calibri",
      "mso-hansi-font-family": "Calibri",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "p",
    staticStyle: {
      "margin-top": "0.0000pt",
      "margin-right": "0.0000pt",
      "margin-bottom": "0.0000pt",
      "margin-left": "0.0000pt",
      "padding": "0pt 0pt 0pt 0pt",
      "mso-pagination": "widow-orphan",
      "mso-line-height-alt": "12pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('font', {
    attrs: {
      "face": "宋体"
    }
  }, [_vm._v("广州市越秀区东平大马路8号大院2号楼")]), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("11")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  }), _c('font', {
    attrs: {
      "face": "Calibri"
    }
  }, [_vm._v("12")]), _c('font', {
    attrs: {
      "face": "宋体"
    }
  })], 1), _c('span', {
    staticStyle: {
      "mso-spacerun": "'yes'",
      "font-family": "Calibri",
      "mso-fareast-font-family": "宋体",
      "mso-bidi-font-family": "'Times New Roman'",
      "font-size": "12.0000pt",
      "mso-font-kerning": "0.0000pt"
    }
  }, [_c('o:p')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-family": "Symbol",
      "mso-fareast-font-family": "宋体",
      "font-size": "10.0000pt",
      "mso-font-kerning": "1.0000pt"
    }
  }, [_c('span', {
    staticStyle: {
      "mso-list": "Ignore"
    }
  }, [_vm._v("·"), _c('span', [_vm._v(" ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5317183e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Protocol.vue
// module id = 454
// module chunks = 2